import React from 'react';
import PropTypes from 'prop-types';
import NamedLink from '../../../components/NamedLink/NamedLink';
import { ReactComponent as VerifiedBadge } from '../../../assets/icons/verified-badge.svg';
import css from './AuthorCard.module.css';

const AuthorCard = ({ author }) => {

  const authorId = author?.id?.uuid || author?.id;
  const username = author?.attributes?.profile?.publicData?.username;
  const isVerified = author?.attributes?.profile?.metadata?.verified_by_marketplace === true;
  const authorImage = author?.profileImage?.attributes?.variants?.['profile-avatar'];
  const abbreviatedName = author?.attributes?.profile?.abbreviatedName;

  if (!authorId) {
    console.error('AuthorCard - No valid author ID found:', author);
    return null;
  }

  return (
    <NamedLink
      name="ProfilePage"
      params={{ id: authorId }}
      className={css.authorCardLink}
    >
      <div className={css.authorCard}>
        <div className={css.imageContainer}>
          {authorImage ? (
            <img
              src={authorImage.url}
              width={authorImage.width}
              height={authorImage.height}
              alt={`${username} profile`}
              className={css.authorImage}
            />
          ) : (
            <div className={css.authorImagePlaceholder}>
              {abbreviatedName || username?.charAt(0)?.toUpperCase() || '?'}
            </div>
          )}
        </div>
        <div className={css.authorInfo}>
          <span className={css.username}>{username}</span>
          {isVerified && (
            <VerifiedBadge className={css.verifiedBadge} />
          )}
        </div>
      </div>
    </NamedLink>
  );
};

AuthorCard.propTypes = {
  author: PropTypes.object.isRequired,
};

export default AuthorCard;

